import { render, staticRenderFns } from "./CharacterDisplay.vue?vue&type=template&id=7a7086d6&scoped=true&"
import script from "./CharacterDisplay.vue?vue&type=script&lang=ts&"
export * from "./CharacterDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterDisplay.vue?vue&type=style&index=0&id=7a7086d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7086d6",
  null
  
)

export default component.exports